module.exports = __webpack_public_path__ + "img/antipattern.01813d31.png";